import { UseMantineTableDataOperationsPartialProps } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperationsFromUrlParamState';

export const DEFAULT_DOCUMENTS_TABLE_OPERATIONS: UseMantineTableDataOperationsPartialProps = {
	initialPagination: {
		pageIndex: 0,
		pageSize: 10,
	},
};
